/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { VersionInfo as n } from "./index2.mjs";
import { VersionInfo as B } from "./index2.mjs";
import { openBlock as t, createElementBlock as i, normalizeStyle as s, toDisplayString as l } from "vue";
import p from "../../_virtual/index.mjs";
function f(o, e, m, a, d, c) {
  return t(), i("aside", {
    style: s(o.style),
    onClick: e[0] || (e[0] = (...r) => o.onClick && o.onClick(...r))
  }, l(o.text), 5);
}
const $ = /* @__PURE__ */ p(n, [["render", f]]);
export {
  B as VersionInfo,
  $ as default
};
